import * as React from 'react'
export const NoContentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={320} height={315} fill="none" {...props}>
    <path
      fill="#D2D9EE"
      fillRule="evenodd"
      d="M72.026 99.174c46.512-28.816 74.722 52.026 110.733 49.909 61.866-3.639 104.959 34.484 39.219 84.946-24.689 18.957-81.058 52.274-158.555 3.235-44.675-28.27-49.426-102.144 8.603-138.09ZM171.595 280.755c-5.449 6.01-14.39 7.978-19.794 4.853-7.923-4.583-3.705-13.983 3.113-12.747 7.962 1.441 13.257.256 17.812-.332 3.889-.503 3.572 3.045-1.131 8.226Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      d="m72.012 302.892-.728-8.532 7.406-.01.189 8.515a25.617 25.617 0 0 1 2.013 2.932c-2.899 1.397-7.757 1.397-10.672-1.318l1.787-1.587h.005Z"
    />
    <path
      fill="#6684C2"
      d="M78.334 314.804H64.65c-3.045-.206-2.084-3.715 0-5.377l5.576-4.948c3.994.159 7.87.81 10.672 1.318 3.06 5.223 2.245 9.023-2.559 9.007h-.005Z"
    />
    <path
      fill="#F0C4BA"
      d="m86.976 300.431.955-7.907 6.964.614-1.053 6.705 5.323 2.482c-2.273 3.805-9.29 4.864-14.035 2.916.486-1.349 1.133-2.932 1.846-4.816v.006Z"
    />
    <path
      fill="#6684C2"
      d="M111.758 312.37H86.9c-3.282-1.339-3.169-3.255-1.77-7.124 5.98-.158 10.898-1.174 14.035-2.916l12.593 5.88c3.326 1.053 3.666 3.948 0 4.16Z"
    />
    <path
      fill="#B8C1BF"
      fillRule="evenodd"
      d="m66.75 182.128 35.249-.587 4.183 28.117c-12.74-3.567-27.033-2.524-41.819 0l2.392-27.53h-.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#1D2342"
      fillRule="evenodd"
      d="M88.325 181.223c-4.885-16.935 13.63-28.033 16.319-17.443 13.479 53.012 7.757 69.72-8.729 135.957l-10.132-1.804c9.787-56.627 11.746-84.793 2.542-116.71ZM85.07 178.217c-.178-15.289-19.481-17.983-20.027-8.42-2.915 51.155 2.03 78.807 5.215 132.348l10.154-.603c.496-47.323 5.166-79.272 4.664-123.325h-.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      fillRule="evenodd"
      d="M120.498 139.965c-1.01-4.345-12.054-2.466-11.73 4.44l5.733 32.415c.777 3.641 5.522 3.355 5.943-.984 1.209-12.315 2.456-25.493.048-35.871h.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#DBDCDD"
      fillRule="evenodd"
      d="M111.094 100.146c-2.736-9.399-19.66-8.14-14.753 6.658l12.529 38.083c4.896 10.547 13.577 3.26 12.114-3.943l-9.89-40.798Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      fillRule="evenodd"
      d="M114.198 174.798c.038.715-.75 2.789-1.263 3.408-1.555 1.874-1.954 1.276-3.039 5.88-.372 1.572-1.323 3.011-.41 3.308 1.365.444 2.235-.466 2.742-2.096.302-.968.588-1.852.799-2.075.286-.306.599.794.491 1.572-.281 2.038-.896 5.367-1.695 7.139-1.241 2.768.956 3.255 1.987 1.376 1.052-1.921 1.414-3.286 1.732-5.546.2.069.313.201.319.392.043 2.318-.518 5.012-1.36 7.282-.616 1.651 1.236 2.773 2.045.794.988-2.414 1.625-4.964 1.668-7.351l.152-.064c.259 1.773.286 3.244.167 5.023-.151 2.281 1.792 2.122 2.224-.133.426-2.212.275-4.323-.027-6.885.189-.106.324-.058.389.249.188.905.615 2.646.95 4.371.27 1.403 1.873 1.223 1.873-.238 0-2.069-.346-4.985-.896-7.917-.653-3.466-1.96-4.287-2.467-8.436l-6.381-.042v-.011Z"
      clipRule="evenodd"
    />
    <path fill="#EBAB9C" d="m113.232 169.644 7.73.767c.135-1.45.259-2.9.372-4.355l-8.345 2.233.238 1.355h.005Z" />
    <path
      fill="#DBDCDD"
      fillRule="evenodd"
      d="m108.309 144.072 4.405 24.894 9.743-.497c.886-10.145.416-21.72-1.813-28.779-1.345-4.255-12.659-2.53-12.33 4.376l-.005.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#AEB7B5"
      fillRule="evenodd"
      d="M92.066 83.83c-4.718-1.593-11.18-2.62-15.827-1.561 0 0 .184 12.553 10.51 12.257 13.296-.376 5.317-10.696 5.317-10.696Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      d="M91.72 99.818c-3.864-.429-15.297-8.69-13.516-13.019 2.332-.328 4.847-.476 7.54-.445 3.094.038 6.041.366 8.757.969.313 2.276.032 10.839-2.78 12.495Z"
    />
    <path
      fill="#54ACD3"
      d="M59.354 103.343c.766-4.573 2.629-8.156 5.473-10.828 3.245-3.054 7.763-4.917 13.377-5.716 1.177 4.334 8.534 9.436 12.394 9.865 2.812-1.657 4.216-7.065 3.903-9.341 4.242.947 7.929 2.572 10.758 4.858 4.065 3.287 6.348 7.928 5.954 13.839-.146 2.128-.497 5.626-.966 9.833-1.771 15.893-5.193 41.867-5.193 41.867.086.434.151.858.221 1.281-12.415 2.683-26.31 1.932-39-1.254.107-.159.21-.318.323-.477-2.148-10.875-10.273-35.802-7.244-53.927Z"
    />
    <path
      fill="#071B45"
      d="M63.705 162.346a26.995 26.995 0 0 1 2.564-4.599c12.69 3.18 26.585 3.937 39.001 1.254.28 1.741.431 3.398.464 4.964.254 14.088-9.285 21.227-21.188 21.275-21.095.079-25.603-11.86-20.842-22.889v-.005Z"
    />
    <path
      fill="#EDEEEF"
      fillRule="evenodd"
      d="M93.232 86.762c11.039 2.053 18.991 8.536 18.289 18.962-.146 2.127-.497 5.626-.966 9.833-1.771 15.893-4.891 41.872-4.891 41.872 5.042 17.666 7.914 48.154 7.914 48.154s-5.906 7.563-17.334 8.722c-9.306-35.855-1.77-73.594.896-97.79 1.053-9.568 1.647-27.636-3.908-29.753Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M96.428 129.613c.993-3.958 3.795-17.734 6.877-25.085l-4.216-3.456 3.622-3.218-7.05-11.298-3.595-2.731c3.023 6.197 5.16 26.625 4.362 45.783v.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="m76.655 83.46 23.638 44.084s.621.476.621 2.81c0 2.022 2.137 28.753-5.987 72.44-1.824 9.823-2.904-7.642-2.904-7.642l-2.829-65.115L76.66 83.46h-.005Z"
      clipRule="evenodd"
      opacity={0.1}
    />
    <path
      fill="#EDEEEF"
      fillRule="evenodd"
      d="M63.321 158.175c2.91-10.706-6.121-29.964-7.265-53.208-.497-10.04 10.569-17.194 21.959-18.507-2.208 7.51 20.518 42.433 20.518 42.433 1.485 27.98-.594 51.589-10.11 85.401-21.782-.09-34.197-6.97-34.197-6.97 0-17.464 4.027-30.525 9.09-49.149h.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M98.533 128.899c-3.055-3.064-12.631-13.966-18.548-17.888l1.102-5.583-5.096-1.445-4.216-17.062 4.459-4.663 22.3 46.635v.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#DBDCDD"
      fillRule="evenodd"
      d="m69.913 109.704-6.91 35.214c-1.884-10.621-6.186-24.392-6.953-39.951-.178-3.63 12.378-1.937 13.814 2.784l.043 1.953h.006Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      fillRule="evenodd"
      d="M45.524 147.353c-1.77-4.107 8.313-8.912 12.162-3.117l14.672 29.588c1.538 3.398-2.478 5.885-5.409 2.61-8.324-9.299-17.193-19.275-21.425-29.081Z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEEEF"
      fillRule="evenodd"
      d="M55.16 103.046c2.736-9.399 19.66-8.14 14.752 6.658l-12.528 38.083c-4.897 10.547-13.577 3.26-12.114-3.943l9.89-40.798Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      fillRule="evenodd"
      d="M71.397 172.015c.394.603 2.267 1.831 3.055 2.037 2.38.625 2.348-.085 5.97 3.027 1.237 1.064 2.867 1.688 2.306 2.451-.848 1.143-2.09.905-3.477-.133-.826-.614-1.581-1.164-1.884-1.228-.415-.084-.01.99.54 1.556 1.441 1.493 3.924 3.837 5.63 4.822 2.661 1.534 1.166 3.191-.793 2.254-1.998-.953-3.104-1.858-4.713-3.503-.119.169-.135.344-.027.497 1.344 1.905 3.406 3.773 5.447 5.134 1.484.989.648 2.958-1.188 1.815-2.24-1.392-4.275-3.096-5.738-5.007a9.075 9.075 0 0 1-.162.032c.848 1.588 1.7 2.8 2.856 4.17 1.484 1.763-.19 2.747-1.884 1.17-1.663-1.551-2.802-3.35-4.086-5.605-.216.022-.297.138-.162.424.388.841 1.074 2.498 1.835 4.091.615 1.291-.794 2.069-1.663.878-1.23-1.683-2.693-4.239-3.989-6.938-1.533-3.186-.966-4.599-3.023-8.256l5.15-3.694v.006Z"
      clipRule="evenodd"
    />
    <path fill="#EBAB9C" d="m69.108 167.273-5.819 5.054a347.565 347.565 0 0 1-2.899-3.324l8.103-2.969.615 1.239Z" />
    <path
      fill="#EDEEEF"
      fillRule="evenodd"
      d="m57.864 143.701 11.271 22.725-8.205 5.181c-6.764-7.727-13.285-17.385-15.681-24.392-1.447-4.223 8.766-9.304 12.615-3.514Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3D3D3"
      d="M96.053 133.768c.552-.076.886-.933.745-1.915-.14-.981-.702-1.715-1.254-1.639-.552.076-.885.933-.745 1.915.14.981.702 1.715 1.254 1.639ZM96.471 153.884c.56-.007 1.004-.817.99-1.807-.014-.991-.48-1.788-1.04-1.781-.56.008-1.004.817-.99 1.808.014.991.48 1.788 1.04 1.78ZM95.251 174.477c.169-.977-.14-1.843-.69-1.934-.55-.091-1.132.627-1.3 1.604-.168.977.14 1.843.69 1.934.55.091 1.132-.627 1.3-1.604Z"
    />
    <path
      fill="#F0C4BA"
      d="M83.114 68.444a16.216 16.216 0 0 1 2.23-5.839l-1.766-.31-4.5 25.738 13.876 2.431.663-7.004a8.298 8.298 0 0 1-2.441-.055c-5.727-1.01-9.334-7.708-8.062-14.961Z"
    />
    <path
      fill="#EBAB9C"
      d="M85.334 62.601a16.216 16.216 0 0 0-2.23 5.839c-1.272 7.254 2.345 13.955 8.066 14.952a8.63 8.63 0 0 0 2.441.055l1.817-19.078-10.094-1.768Z"
    />
    <path
      fill="#F0C4BA"
      fillRule="evenodd"
      d="M88.014 42.526c-9.14.47-8.432 7.473-7.945 18.782.452 10.588 6.427 17.42 13.988 19.205 11.694 2.764 10.1-5.284 9.559-17.32-.752-16.611-6.466-21.127-15.602-20.667Z"
      clipRule="evenodd"
    />
    <path
      fill="#EBAB9D"
      fillRule="evenodd"
      d="M100.388 48.301s.29 7.733-9.854 1.92c-5.313-3.045-9.765-6.972-9.765-6.972l17.555 1.46 2.064 3.592Z"
      clipRule="evenodd"
    />
    <path
      fill="#2F1D19"
      fillRule="evenodd"
      d="M100.753 60.377c-.349.016-.605.603-.576 1.31.03.708.351 1.27.703 1.243.349-.016.609-.613.576-1.31-.03-.708-.354-1.26-.703-1.243ZM91.313 60.85c-.47.023-.824.616-.785 1.326.039.711.448 1.264.918 1.24.47-.024.824-.617.785-1.327-.03-.708-.449-1.264-.918-1.24Z"
      clipRule="evenodd"
    />
    <path
      fill="#A7A0AF"
      d="M80.937 56.319c-.829-4.053-.288-7.935 2.023-9.643l.011-.028c3.789-8.294 14.263 3.296 16.373 1.19 2.59-2.575 3.449 1.65 3.444 3.82 1.049-.926 2.309-3.131-1.393-7.479-1.428-1.67-4.999-4.093-8.337-4.993-9.296-2.512-12.892 4.325-12.892 4.325s-8.227 1.417-5.554 13.56c.191.844.455 1.694.749 2.524 2.103.043 4.144-.986 5.585-3.273l-.01-.003Z"
    />
    <path
      fill="#71667C"
      d="M99.344 47.839c-2.116 2.092-12.58-9.494-16.373-1.19l-.01.027c.774-.571 1.757-.902 2.957-.904 4.472.006 10.1 5.924 12.417 3.308 1.644-1.866 2.822.458 3.612 3.125 0 0 .403-.157.841-.546-.005-2.175-.864-6.4-3.453-3.824l.01.004ZM77.802 65.227c1.265 3.105 3.96 4.007 3.908 1.118-.005-.099.015-.209.034-.34-.042-.787.75-2.443 1.016-3.67.055-.396.048-.742-.075-.981-.81-1.605-1.4-3.34-1.745-5.045-1.44 2.287-3.492 3.313-5.576 3.276.823 2.274 1.93 4.366 2.438 5.642Z"
    />
    <path
      fill="#EFC3BA"
      fillRule="evenodd"
      d="M79.577 59.739c-1.69.639-2.366 2.971-1.52 5.21.847 2.24 2.908 3.541 4.588 2.898 1.69-.639 2.366-2.971 1.52-5.21-.847-2.24-2.899-3.538-4.588-2.898Z"
      clipRule="evenodd"
    />
    <path
      fill="#B58180"
      fillRule="evenodd"
      d="M81.968 62.557c.135-.548-.583-1.218-1.565-1.143-1.337.11-1.559 2.091-.836 3.395.353-1.289 2.26-1.685 2.401-2.252Z"
      clipRule="evenodd"
    />
    <path
      fill="#EBAB9D"
      d="M95.706 58.738c-.87.93-.963 6.836-.519 9.147.051-.077.093-.157.168-.214.439-.336 1.155-.137 1.599.44.443.575.446 1.326.016 1.665a.804.804 0 0 1-.267.112c.901.387 2.004.273 2.888.032 2.681-.742-2.647-12.518-3.885-11.182Z"
    />
    <path
      fill="#B58180"
      d="M96.944 68.106c-.443-.576-1.16-.774-1.598-.439-.076.057-.117.138-.168.215.023.137.053.255.082.373.221.823.753 1.337 1.392 1.624l.028.01c.097-.027.19-.045.268-.111.452-.341.45-1.092-.004-1.672Z"
    />
    <path
      fill="#B58180"
      fillRule="evenodd"
      d="M92.842 75.344c2.243-1.275 4.313-1.36 6.22-.206.077-2.74-6.303-2.744-6.22.206Z"
      clipRule="evenodd"
    />
    <path
      fill="#A7A0AF"
      fillRule="evenodd"
      d="M86.184 60.153c-.2-.15 1.542-4.795 5.178-4.337 2.053.26 2.284 2.456 1.433 2.388-3.678-.292-6.412 2.1-6.611 1.95ZM102.533 58.295c.095-.081-.902-2.796-3.26-2.423-1.026.165-.624 1.635.066 1.62 1.857-.04 3.108.888 3.194.803Z"
      clipRule="evenodd"
    />
    <path
      fill="#EBAB9D"
      fillRule="evenodd"
      d="M89.987 53.952c-.328.186 10.456 1.296 11.492.825 1.049-.477-8.545-2.514-11.492-.825Z"
      clipRule="evenodd"
    />
    <path
      fill="#121426"
      fillRule="evenodd"
      d="M180.348 82.233c.977 7.541 10.321 3.849 7.181 10.322-7.454 15.356 36.454 20.809 43.018 15.704 10.128-7.869-8.186-12.858-1.432-17.3 3.575-2.348 4.307-7.214-.956-12.155-5.839-5.483-31.448-25.388-41.483-24.652-2.555.189-1.712 6.222-1.639 9.145.285 11.708-5.65 11.518-4.689 18.936Z"
      clipRule="evenodd"
    />
    <path
      fill="#DBDCDD"
      fillRule="evenodd"
      d="M192.195 91.506c4.67-1.726 10.17-2.8 14.845-1.874 0 0 1.112 12.416-9.22 12.416-13.301 0-5.625-10.542-5.625-10.542Z"
      clipRule="evenodd"
    />
    <path
      fill="#B8C1BF"
      fillRule="evenodd"
      d="m215.299 176.075-39.114.509-3.822 28.234c14.03-3.959 29.911-3.361 46.391-1.302l-3.455-27.446v.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      d="M199.434 73.126a13.056 13.056 0 0 1 3.601 7.483c.793 6.34-3.131 11.812-8.772 12.22-.205.01-.416.005-.626.01l-.038 5.721 13.689-.968-1.83-24.89-6.024.424Z"
    />
    <path
      fill="#EBAB9C"
      d="M203.029 80.62a13.016 13.016 0 0 0-3.6-7.484l-5.673.402-.125 19.312c.211 0 .411 0 .627-.01 5.64-.403 9.576-5.88 8.771-12.22Z"
    />
    <path
      fill="#DBDCDD"
      fillRule="evenodd"
      d="M178.831 106.316c7.141-12.003 28.207-16.832 21.011-2.086-2.853 5.842-10.073 15.005-10.073 15.005l-15.474 21.576c-6.463 8.347-12.317.789-9.508-5.19l14.044-29.305Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      fillRule="evenodd"
      d="M158.54 113.695c-.269-.543-.321-2.465-.106-3.145.651-2.053 1.177-1.738.523-5.752-.22-1.371.078-2.861-.77-2.745-1.267.169-1.673 1.206-1.547 2.677.076.875.135 1.675.043 1.928-.13.346-.755-.397-.928-1.046-.451-1.699-1.058-4.54-.998-6.235.093-2.636-1.871-2.187-2.088-.326-.218 1.899-.06 3.108.432 4.995-.188.021-.324-.043-.391-.183-.812-1.796-1.253-4.12-1.324-6.22-.05-1.528-1.937-1.705-1.943.15-.007 2.265.327 4.499 1.086 6.386a1.74 1.74 0 0 0-.1.11c-.803-1.29-1.321-2.437-1.818-3.871-.637-1.846-2.176-.99-1.776.941.389 1.894 1.222 3.492 2.321 5.386-.118.154-.245.164-.403-.051-.455-.641-1.389-1.837-2.24-3.071-.692-.994-1.946-.254-1.454.892.695 1.622 1.946 3.773 3.383 5.862 1.695 2.466 3.037 2.619 4.841 5.678l5.243-2.37.014.01Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      fillRule="evenodd"
      d="M165.375 143.352c2.325 3.103 11.33-1.88 8.662-7.277l-15.907-23.794c-1.892-2.622-6.954-.606-4.842 4.035 3.379 9.821 5.657 18.407 11.21 25.819l.877 1.217Z"
      clipRule="evenodd"
    />
    <path
      fill="#EBAB9C"
      fillRule="evenodd"
      d="m161.687 117.602-1.924-2.871-5.639 4.063.577 2.049 6.986-3.241Z"
      clipRule="evenodd"
    />
    <path
      fill="#DBDCDD"
      fillRule="evenodd"
      d="m162.701 142.743-9.896-21.6 8.058-5.032c6.404 7.66 11.836 14.704 14.021 21.621 1.316 4.17-8.565 10.744-12.183 5.011Z"
      clipRule="evenodd"
    />
    <path
      fill="#44112D"
      fillRule="evenodd"
      d="M202.236 71.242c.227-.08-.049-3.72-2.856-3.911-1.803-.122-2.067 1.047-1.333 1.127 3.163.355 3.967 2.868 4.194 2.778l-.005.006ZM188.228 68.193c-.097-.08 1.187-1.99 2.731-1.672.988.201.767.878.346.804-1.776-.285-2.98.948-3.077.868Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      d="m211.596 301.216.961-11.807-7.163.19-.448 11.786a25.595 25.595 0 0 0-1.857 2.884c2.596-.54 6.137-1.244 9.846-1.529l-1.344-1.519.005-.005Z"
    />
    <path
      fill="#6684C2"
      d="m205.82 312.89 11.422-.317c2.937-.286 1.307-3.631-.151-5.197l-4.145-4.647c-3.709.286-7.261.979-9.847 1.53-2.807 5.138-1.927 8.785 2.721 8.636v-.005Z"
    />
    <path
      fill="#F0C4BA"
      d="m197.065 299.242-2.467-11.702-6.095 1.355 1.927 10.553-4.016 2.445c3.072 1.27 7.422 1.942 12.572 1.942-.513-1.286-1.171-2.799-1.916-4.593h-.005Z"
    />
    <path
      fill="#6684C2"
      d="m178.247 311.313 19.228-.54c3.131-1.386 2.969-3.228 1.506-6.938-5.15 0-9.512-.661-12.572-1.942l-8.875 5.414c-1.986 1.08-2.839 3.906.713 4.006Z"
    />
    <path
      fill="#F0C4BA"
      d="M193.615 106.303c3.714-.286 10.813-8.436 14.359-12.68-2.175-.318-4.572-.524-7.206-.662-3.196-.175-6.003.217-8.465 1.005-.264 2.09-1.193 10.754 1.312 12.337Z"
    />
    <path
      fill="#54ACD3"
      d="M175.051 115.141c-.966 2.974-.464 6.726 3.622 8.928-.334 13.357 3.568 21.285 5.048 30.89-2.251 2.244-3.914 4.515-5.091 6.732 11.482 3.091 24.518 3.043 36.648.678-1.771-2.678-4.119-5.118-6.672-7.5.901-3.9 3.681-9.018 6.542-14.876 1.868-3.821 4.794-10.039 6.748-15.607 1.894-5.408 2.747-11.061 2.013-16.496-1.247-9.388-6.364-12.87-15.93-14.252-3.546 4.245-9.084 6.06-12.798 6.356-2.505-1.582-3.131-3.932-2.878-6.012-10.871 3.477-15.19 14.84-17.246 21.164l-.006-.005Z"
    />
    <path
      fill="#1D2342"
      d="M217.399 166.475c-.534-1.434-1.258-2.799-2.127-4.112-12.124 2.371-25.155 2.424-36.647-.677a20.005 20.005 0 0 0-1.334 3.101c-4.232 12.839 7.741 23.736 21.474 22.968 12.237-.682 19.816-7.139 19.698-15.717-.027-1.969-.422-3.816-1.069-5.563h.005Z"
    />
    <path
      fill="#1D2342"
      fillRule="evenodd"
      d="M194.857 185.141c4.95-14.924-16.324-24.17-18.311-18.491-16.129 46.027-6.153 67.275 11.687 125.495l9.895-.815c-5.339-34.86-15.433-69.577-3.271-106.189Z"
      clipRule="evenodd"
    />
    <path
      fill="#1D2342"
      fillRule="evenodd"
      d="M196.741 181.77c-1.058-13.617 18.779-24.233 21.667-11.664 9.264 40.39-2.407 85.686-5.025 123.695l-9.949-.259c-1.711-42.238-3.638-72.498-6.693-111.777v.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEEEF"
      fillRule="evenodd"
      d="M191.013 94.093c-9.177 3.08-10.51 7.865-15.007 16.115-2.024 3.721-5.576 10.098 2.041 15.115-.821 8.393 3.654 15.591-.702 30.885-5.09 17.867-9.808 47.884-9.808 47.884s6.672 6.536 19.411 6.78c3.12-39.327 6.505-51.457 1.647-90.032-1.058-8.383.766-21.788 2.423-26.752l-.005.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M190.452 129.684c-2.24-3.599-6.278-13.951-7.709-20.322l3.73-2.996-3.152-2.852 6.283-9.85 2.591-2.153c-2.704 5.409-3.848 20.973-1.749 38.178l.006-.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="m205.243 93.697-20.2 35.558s-.605 1.746-.907 3.498c-.302 1.752-5.738 23.318 3.984 65.492 2.85 12.357 2.958-1.075 2.958-1.075l2.413-62.665 11.746-40.803.006-.005Z"
      clipRule="evenodd"
      opacity={0.1}
    />
    <path
      fill="#EDEEEF"
      fillRule="evenodd"
      d="M214.716 156.732c-5.193-13.458 10.953-26.99 9.247-48.916-.685-8.79-6.294-14.474-17.83-14.638 1.873 6.605-19.152 33.844-19.924 37.67-6.192 30.684.891 57.865 7.433 80.601 20.275-.048 33.689-6.415 33.689-6.415-1.91-15.765-5.986-31.128-12.615-48.302Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M186.214 130.848c1.954-3.059 18.246-13.389 22.435-17.692l-2.052-4.276 3.995-2.149-.259-13.913-3.422-3.223-20.702 41.253h.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3D3D3"
      d="M189.184 133.495c.154-.944-.131-1.774-.637-1.853-.506-.08-1.042.62-1.197 1.564-.154.943.131 1.773.637 1.853.506.08 1.042-.621 1.197-1.564ZM187.049 150.861c.044-.954-.337-1.746-.849-1.769-.512-.022-.962.734-1.006 1.689-.043.955.337 1.747.85 1.769.512.022.962-.734 1.005-1.689ZM187.155 172.173c.509-.061.826-.879.708-1.828-.117-.949-.626-1.669-1.135-1.608-.509.061-.826.879-.708 1.828.118.949.626 1.669 1.135 1.608Z"
    />
    <path
      fill="#ECAC9D"
      d="M207.769 77.605a13.54 13.54 0 0 0-2.422-8.281l-5.895-.61-3.413 19.669c.214.038.426.083.637.104 5.863.607 10.831-4.267 11.084-10.877l.009-.005Z"
    />
    <path
      fill="#F0C4BB"
      d="M211.202 69.78c.843-10.263 3.159-17.68-6.563-18.696a27.71 27.71 0 0 0-3.07-.152c.37 1.508-2.205 10.027-7.996 8.924-5.048-.956-5.389 4.825-6.188 6.874-.006.696-.005 1.418.028 2.166.431 9.843-.188 16.31 9.685 16.385 7.576.055 13.312-5.897 14.097-15.504l.007.003Z"
    />
    <path
      fill="#ECAC9D"
      d="M195.242 62.992c9.432 1.839 6.695-10.545 6.328-12.06-7.841.064-14.017 3.975-14.184 15.798.799-2.049 2.81-4.725 7.856-3.738Z"
    />
    <path
      fill="#2F1D18"
      fillRule="evenodd"
      d="M191.756 66.544c.51.07.884.814.84 1.669-.042.845-.481 1.487-1.001 1.413-.521-.074-.884-.814-.84-1.668.044-.854.48-1.487 1.001-1.414ZM201.012 67.44c.535.05.901.76.812 1.596-.089.836-.593 1.472-1.128 1.422-.534-.05-.901-.761-.811-1.597.089-.836.59-1.464 1.127-1.422Z"
      clipRule="evenodd"
    />
    <path
      fill="#1F284B"
      d="M199 55.562s.108.215.306.577c3.753 3.636 10.919 1.386 9.39 11.945-.019.158-.01.357.023.58a.878.878 0 0 0 .643-.365 9.647 9.647 0 0 0-.335 1.712c.337 1.207.764 2.537.47 3.046-.07.118-.117.237-.182.365 2.227 7.685 14.488 11.693 18.378 5.254-2.905-3.26-8.293-5.99-4.512-10.69 12.022-14.982-9.308-27.254-21.826-19.265-6.95-4.496-16.173.322-16.796 6.003-.197 1.835-.1 3.96.184 5.755.984-8.672 12.526-2.66 14.266-4.922l-.009.005Z"
    />
    <path
      fill="#121426"
      d="M209.307 73.42c-7.183 13.407-2.201 19.776 3.299 19.776 2.395-2.811 16.8-12.594 15.087-14.52-3.893 5.975-16.061 1.377-18.378-5.254l-.008-.003ZM208.709 68.668c.051.393.176.857.308 1.347a9.74 9.74 0 0 1 .335-1.712.879.879 0 0 1-.643.365ZM187.377 63.205c2.424-6.78 8.672-4.188 11.511-7.499.136.154.275.3.415.44l-.306-.577c-1.731 2.257-13.272-3.755-14.266 4.922.516 3.304 1.652 5.491 2.644 2.72l.002-.006Z"
    />
    <path
      fill="#F0C3BA"
      fillRule="evenodd"
      d="M210.823 68.503c1.518.654 2.119 2.618 1.346 4.39-.773 1.774-2.637 2.689-4.155 2.035-1.518-.654-2.12-2.618-1.346-4.391.773-1.773 2.637-2.688 4.155-2.034Z"
      clipRule="evenodd"
    />
    <path
      fill="#ECAC9D"
      d="M195.998 73.38c-.426-.358-.398-1.094.077-1.64.475-.544 1.207-.708 1.64-.348a.697.697 0 0 1 .168.204c.476-1.973.213-5.11-.701-5.232-1.835-.247-6.454 5.25-3.843 7.019.763.513 1.984.46 2.912.14a.737.737 0 0 1-.248-.134l-.005-.01Z"
    />
    <path
      fill="#B58281"
      d="M197.779 71.97c.039-.121.078-.242.107-.382a.877.877 0 0 0-.169-.203c-.426-.357-1.165-.196-1.64.349-.474.544-.512 1.285-.076 1.638.076.064.161.1.247.135.017-.003.036-.012.053-.014.669-.247 1.221-.728 1.478-1.523Z"
    />
    <path
      fill="#121426"
      fillRule="evenodd"
      d="M205.421 67.784c.234-.125-.449-4.222-3.515-4.063-1.973.103-2.127 1.465-1.321 1.464 3.459-.024 4.6 2.732 4.836 2.599ZM189.61 64.79c-.111-.078 1.065-2.368 2.808-2.199 1.119.113.945.888.484.858-1.992-.112-3.17 1.415-3.282 1.337l-.01.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#B58281"
      fillRule="evenodd"
      d="M208.842 70.478c-.106-.539.625-1.164 1.581-1.042 1.3.164 1.424 2.114.662 3.343-.284-1.264-2.135-1.745-2.243-2.3ZM192.635 79.108c2.001-1.007 5.362-.212 7.205.72-1.123-2.626-6.305-4.386-7.205-.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#DBDCDD"
      d="M218.456 134.652c2.765-7.604 4.77-15.75 3.695-23.484-.721-5.173-2.444-8.56-5.315-10.717-1.89-1.416-9.069 5.512-5.263 26.711 2.148 11.973 6.186 9.42 6.888 7.49h-.005Z"
    />
    <path
      fill="#EDEEEF"
      fillRule="evenodd"
      d="M212.427 120.627c-5.563-12.812 2.836-32.726 10.593-18.266 3.07 5.73 6.283 16.944 6.283 16.944l8.457 25.169c2.993 10.124-6.561 10.454-9.769 4.68l-15.564-28.527Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      fillRule="evenodd"
      d="M206.55 141.402c-.597-.099-2.187-1.18-2.614-1.753-1.284-1.728-.721-1.97-4.36-3.787-1.241-.623-2.275-1.735-2.677-.98-.604 1.127 0 2.062 1.267 2.82.755.45 1.438.87 1.59 1.093.204.308-.763.38-1.392.14-1.641-.626-4.302-1.795-5.641-2.835-2.085-1.617-2.869.239-1.486 1.503 1.414 1.287 2.487 1.866 4.306 2.571-.094.164-.224.237-.378.209-1.932-.391-4.074-1.391-5.82-2.562-1.269-.853-2.516.575-1.013 1.664 1.832 1.33 3.84 2.365 5.815 2.852.008.051.017.096.031.146-1.517-.103-2.751-.353-4.204-.788-1.87-.562-2.075 1.186-.275 1.991 1.764.792 3.547 1.05 5.727 1.266.055.186-.01.295-.278.297-.785-.006-2.302.052-3.8.022-1.211-.02-1.345 1.43-.127 1.701 1.722.384 4.199.627 6.734.683 2.991.066 3.899-.933 7.436-.608l1.143-5.64.016-.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#F0C4BA"
      fillRule="evenodd"
      d="M234.606 153.196c3.878-.072 5.1-10.29-.838-11.282l-28.605-1.006c-3.233.002-4.557 5.288.443 6.288 9.943 3 18.24 6.172 27.5 6h1.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#EBAB9C"
      fillRule="evenodd"
      d="m211.56 141.133-3.454-.117-.001 6.95 2 .73 1.455-7.563Z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEEEF"
      fillRule="evenodd"
      d="m232.549 155.009-23.31-4.6.63-9.479c9.959-.717 18.849-1.006 25.737 1.266 4.153 1.371 3.71 13.23-3.057 12.813Z"
      clipRule="evenodd"
    />
    <path
      fill="#3E84ED"
      d="M231.116 35.986c0-19.77 19.89-35.79 44.43-35.79s44.43 16.02 44.43 35.79-19.89 35.79-44.43 35.79c-3.75 0-7.39-.38-10.87-1.08-3.79 3.93-9.18 8-12.51 8.38-3.64.42 2.43-5.55 4-10.87-14.83-5.8-25.06-18.04-25.06-32.21l.01-.01Z"
      opacity={0.3}
    />
    <path
      fill="#3E84ED"
      d="M265.892 42.627v3.569h-13.467a9.227 9.227 0 0 1 1.312-3.828c.729-1.213 2.17-2.817 4.321-4.813 1.731-1.613 2.793-2.707 3.185-3.281.529-.793.793-1.577.793-2.352 0-.856-.232-1.513-.697-1.968-.456-.465-1.089-.698-1.901-.698-.802 0-1.44.242-1.914.725s-.747 1.285-.82 2.406l-3.828-.383c.228-2.114.943-3.632 2.146-4.552 1.204-.92 2.707-1.381 4.512-1.381 1.978 0 3.532.533 4.662 1.6 1.13 1.066 1.696 2.392 1.696 3.978 0 .902-.164 1.764-.493 2.584-.319.811-.829 1.663-1.531 2.557-.465.592-1.303 1.444-2.515 2.556-1.213 1.112-1.983 1.85-2.311 2.215-.319.365-.579.72-.779 1.066h7.629Zm9.105-16.556c1.941 0 3.459.692 4.553 2.078 1.303 1.64 1.955 4.361 1.955 8.162 0 3.792-.656 6.517-1.969 8.176-1.085 1.367-2.598 2.05-4.539 2.05-1.95 0-3.523-.747-4.717-2.242-1.194-1.504-1.791-4.179-1.791-8.025 0-3.773.656-6.49 1.969-8.148 1.085-1.368 2.598-2.051 4.539-2.051Zm0 3.185a1.9 1.9 0 0 0-1.244.451c-.365.292-.647.82-.848 1.587-.264.993-.396 2.665-.396 5.017 0 2.352.118 3.97.355 4.854.237.875.533 1.458.889 1.75.364.291.779.437 1.244.437.465 0 .88-.146 1.244-.437.365-.301.647-.834.848-1.6.264-.984.396-2.652.396-5.004 0-2.352-.118-3.965-.355-4.84-.237-.884-.538-1.472-.902-1.764a1.85 1.85 0 0 0-1.231-.45Zm16.625 16.94v-4.033h-8.203v-3.364l8.695-12.728h3.227v12.715h2.488v3.377h-2.488v4.033h-3.719Zm0-7.41v-6.85l-4.607 6.85h4.607Z"
    />
  </svg>
)
